import { createSlice } from "@reduxjs/toolkit";
import { loginAction, logoutAction, updateProfileAction } from "../actions/authActions";

const initial_state = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  sign_in_mail: "",
  userInfo: null,
  isAuthenticated: false,
};

const create_auth_slice = createSlice({
  name: "auth",
  initialState: initial_state,
  reducers: {
    set_signin_mail: (state, action) => {
      state.sign_in_mail = action.payload;
    },
    clear_user_info: () => {
      return initial_state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAction.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.userInfo = action?.payload?.data?.user;
      })
      .addCase(logoutAction.fulfilled, () => initial_state)
      .addCase(updateProfileAction.fulfilled, (state, action) => {
        // Update userInfo with new profile data if returned
        if (action.payload?.data) {
          state.userInfo = {
            ...state.userInfo,
            ...action.payload.data
          };
        }
      });
  },
});

export const { set_signin_mail, clear_user_info } = create_auth_slice.actions;
export default create_auth_slice.reducer;
